import { Pipe, PipeTransform } from '@angular/core';
import { ServiceModel } from '@app/core/models';

@Pipe({
  name: 'filterByServiceType',
  pure: true,
  standalone: true,
})
export class FilterByServiceTypePipe implements PipeTransform {
  transform(
    services: ServiceModel[],
    filterType: 'all' | 'services' | 'vouchers',
  ): ServiceModel[] {
    if (!services || !filterType) {
      return services;
    }

    switch (filterType) {
      case 'all': {
        return services;
      }
      case 'services': {
        // Return all services except vouchers
        return services.filter((service) => service.serviceType !== 'voucher');
      }
      case 'vouchers': {
        // Return only vouchers
        return services.filter((service) => service.serviceType === 'voucher');
      }
      default: {
        return services;
      }
    }
  }
}
